import { render, staticRenderFns } from "./InventoryShrimpInfo.vue?vue&type=template&id=636b5ac4&scoped=true"
import script from "./InventoryShrimpInfo.vue?vue&type=script&lang=js"
export * from "./InventoryShrimpInfo.vue?vue&type=script&lang=js"
import style0 from "./InventoryShrimpInfo.vue?vue&type=style&index=0&id=636b5ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b5ac4",
  null
  
)

export default component.exports